import { differenceInSeconds } from 'date-fns';
import { usePlaybackStateStore } from '../../store';
import { PlaybackEventEmitter, PlaybackEvent } from '../../events';
export const onSleepTimerCheck = () => {
    const sleepTime = usePlaybackStateStore.getState().sleepTime;
    if (sleepTime) {
        const now = Date.now();
        const diffS = differenceInSeconds(sleepTime, now);
        if (diffS <= 0) {
            PlaybackEventEmitter.emit(PlaybackEvent.STOP);
            usePlaybackStateStore.setState({
                sleepTime: undefined,
            });
        }
    }
};
//# sourceMappingURL=onSleepTimerCheck.js.map